import { render } from "./setting-availability.vue?vue&type=template&id=4f52303a"
import script from "./setting-availability.vue?vue&type=script&lang=js"
export * from "./setting-availability.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__